import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandMark from '../components/BrandMark';
import GradientPill from '../components/GradientPill';

const SLIDES = [
  {
    step: 'STEP 01',
    icon: '📷',
    title: 'Post your best',
    body: 'Drop a photo or short video. Use it as a normal post or stage it for a head-to-head battle.'
  },
  {
    step: 'STEP 02',
    icon: '⚡',
    title: 'Pick a target',
    body: 'Tap Challenge on someone\'s post. The battle goes live instantly — no accept step, no waiting.'
  },
  {
    step: 'STEP 03',
    icon: '🏆',
    title: 'The crowd decides',
    body: 'Anyone except the two creators can vote. Higher-rep voters carry more weight. After 24h, the results lock in.'
  }
];

export default function OnboardingPage() {
  const navigate = useNavigate();
  const [i, setI] = useState(0);
  const slide = SLIDES[i];

  const next = () => {
    if (i < SLIDES.length - 1) setI(i + 1);
    else {
      try { localStorage.setItem('outglow.onboardingSeen', '1'); } catch {}
      navigate('/app', { replace: true });
    }
  };

  const skip = () => {
    try { localStorage.setItem('outglow.onboardingSeen', '1'); } catch {}
    navigate('/app', { replace: true });
  };

  return (
    <div style={{
      minHeight: '100vh',
      padding: 24,
      display: 'flex', flexDirection: 'column',
      background:
        'radial-gradient(circle at 0% 0%, rgba(255,62,127,.18), transparent 35%),' +
        'radial-gradient(circle at 100% 100%, rgba(91,233,255,.14), transparent 40%),' +
        'var(--bg)'
    }}>
      <header className="row" style={{ justifyContent: 'space-between' }}>
        <BrandMark size={28} />
        <button className="btn btn-ghost btn-sm" onClick={skip}>Skip</button>
      </header>

      <main style={{ flex: 1, display: 'grid', placeItems: 'center', textAlign: 'center', padding: '24px 8px' }}>
        <div style={{ maxWidth: 460 }}>
          <div style={{ fontSize: 72, marginBottom: 16, lineHeight: 1 }}>{slide.icon}</div>
          <p className="eyebrow" style={{ color: 'var(--primary)' }}>{slide.step}</p>
          <h1 className="h1" style={{ fontSize: 38, marginTop: 8 }}>{slide.title}</h1>
          <p style={{ color: 'var(--text-dim)', fontSize: 17, lineHeight: 1.55, marginTop: 16 }}>
            {slide.body}
          </p>
        </div>
      </main>

      <footer className="col" style={{ gap: 16, alignItems: 'center' }}>
        <div className="row" style={{ gap: 6 }}>
          {SLIDES.map((_, idx) => (
            <span
              key={idx}
              style={{
                width: idx === i ? 28 : 8,
                height: 8,
                borderRadius: 4,
                background: idx === i ? 'var(--primary)' : 'var(--faint)',
                transition: 'width .2s ease'
              }}
            />
          ))}
        </div>
        <GradientPill label={i === SLIDES.length - 1 ? "Let's go" : 'Next'} onClick={next} size="lg" />
      </footer>
    </div>
  );
}
